{
  "COMPOSE_REDIRECT": {
    "OPENING": "Abriendo una nueva conversación con {email}…",
    "NO_EMAIL": "No se proporcionó ninguna dirección de correo electrónico. Usa ?email=name@example.com",
    "CONTACT_ERROR": "No se pudo encontrar el contacto para {email}."
  },
  "CONVERSATION": {
    "404": "Lo sentimos, no podemos encontrar la conversación. Por favor, inténtalo de nuevo",
    "SELECT_A_CONVERSATION": "Por favor, selecciona una conversación del panel izquierdo",
    "CSAT_REPLY_MESSAGE": "Por favor, valora la conversación",
    "SWITCH_VIEW_LAYOUT": "Cambiar el diseño",
    "DASHBOARD_APP_TAB_MESSAGES": "Mensajes",
    "UNVERIFIED_SESSION": "La identidad de este usuario no está verificada",
    "NO_MESSAGE_1": "¡Oh oh! Parece que no hay mensajes de los clientes en tu bandeja de entrada.",
    "NO_MESSAGE_2": " para enviar un mensaje a tu página!",
    "NO_INBOX_1": "¡Hola! Parece que aún no has añadido ninguna bandeja de entrada.",
    "NO_INBOX_2": " para empezar",
    "NO_INBOX_AGENT": "¡Uh Oh! Parece que no eres parte de ninguna bandeja de entrada. Por favor, contacta con tu administrador",
    "SEARCH_MESSAGES": "Buscar mensajes en conversaciones",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Traducción",
    "EMPTY_STATE": {
      "CMD_BAR": "para abrir el menú de comandos",
      "KEYBOARD_SHORTCUTS": "para ver los atajos del teclado"
    },
    "SEARCH": {
      "TITLE": "Buscar mensajes",
      "RESULT_TITLE": "Buscar resultados",
      "LOADING_MESSAGE": "Cruzando datos...",
      "PLACEHOLDER": "Escriba cualquier texto para buscar mensajes",
      "NO_MATCHING_RESULTS": "No se encontraron resultados."
    },
    "UNREAD_MESSAGES": "Mensajes no leídos",
    "UNREAD_MESSAGE": "Mensaje sin leer",
    "CLICK_HERE": "Haz clic aquí",
    "LOADING_INBOXES": "Cargando bandeja de entrada",
    "LOADING_CONVERSATIONS": "Cargando conversaciones",
    "CANNOT_REPLY": "No puede responder debido a",
    "24_HOURS_WINDOW": "Restricción de la ventana de mensajes de 24 horas",
    "NOT_ASSIGNED_TO_YOU": "Esta conversación no te está asignada. ¿Quieres asignarla a ti mismo?",
    "ASSIGN_TO_ME": "Asignar a mi",
    "TWILIO_WHATSAPP_CAN_REPLY": "Sólo puede responder a esta conversación usando una plantilla de mensaje debido a",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restricción de la ventana de mensajes de 24 horas",
    "REPLYING_TO": "Esta respondiendo a:",
    "REMOVE_SELECTION": "Eliminar selección",
    "DOWNLOAD": "Descargar",
    "UNKNOWN_FILE_TYPE": "Archivo desconocido",
    "SAVE_CONTACT": "Guardar Contacto",
    "NO_CONTENT": "No hay contenido que mostrar",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Antes de enviar, realice:",
      "EXECUTE": "Ejecutar",
      "RETRY": "Reintentar",
      "CONFIRM": "¿Ejecutar ahora?",
      "CONFIRM_YES": "Sí, ejecutar",
      "CONFIRM_NO": "Cancelar",
      "RUNNING": "Ejecutando…",
      "DONE": "Hecho",
      "CLAIM_DELAYED": "se presentará cuando se entregue el pedido",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Se ha creado una reclamación NUEVA {reference}, {planned} está cerrada — edite el texto del borrador",
        "NEW_CLAIM": "Se ha creado una reclamación NUEVA {reference} en lugar de actualizar {planned} — edite el texto del borrador",
        "OTHER_CLAIM": "Se ha actualizado la reclamación {reference} en lugar de {planned} — edite el texto del borrador",
        "EXISTING_CLAIM": "No se ha creado ninguna reclamación nueva, se ha actualizado la existente {reference} — edite el texto del borrador",
        "OTHER": "Ha ocurrido de forma distinta a lo que suponía el borrador — edite el texto del borrador"
      },
      "FAILED": "Ha fallado",
      "UNREACHABLE": "No se pudo contactar con el bot",
      "REQUEST_FAILED": "No se pudo iniciar la acción, inténtelo de nuevo.",
      "ACTIONS": {
        "CANCEL_ORDER": "Cancelar el pedido",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Cambiar el pago a contra reembolso",
        "CREATE_CLAIM": "Presentar una reclamación",
        "CREATE_OR_UPDATE_CLAIM": "Presentar o actualizar una reclamación",
        "EXTEND_ORDER_PICKUP_DATE": "Ampliar el plazo de recogida"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} ha compartido un contacto",
      "LOCATION": "{sender} ha compartido una ubicación",
      "FILE": "{sender} ha compartido un archivo"
    },
    "UPLOADING_ATTACHMENTS": "Subiendo archivos adjuntos...",
    "REPLIED_TO_STORY": "Respondió a su historia",
    "UNSUPPORTED_MESSAGE": "Este mensaje no es compatible. Puedes ver este mensaje en la aplicación de Facebook/Instagram.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Este mensaje no es compatible. Puedes ver este mensaje en la aplicación de Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Este mensaje no es compatible. Puedes ver este mensaje en la aplicación de Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Mensaje eliminado correctamente",
    "FAIL_DELETE_MESSSAGE": "¡No se pudo eliminar el mensaje! Inténtalo de nuevo",
    "NO_RESPONSE": "No hay respuesta",
    "RESPONSE": "Respuesta",
    "RATING_TITLE": "Calificación",
    "FEEDBACK_TITLE": "Comentarios",
    "REPLY_MESSAGE_NOT_FOUND": "Mensaje no disponible",
    "CARD": {
      "SHOW_LABELS": "Mostrar etiquetas",
      "HIDE_LABELS": "Ocultar etiquetas"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolver",
      "REOPEN_ACTION": "Reabrir",
      "OPEN_ACTION": "Abrir",
      "OPEN": "Más",
      "CLOSE": "Cerrar",
      "DETAILS": "detalles",
      "SNOOZED_UNTIL": "Posponer hasta",
      "SNOOZED_UNTIL_TOMORROW": "Pospuesto hasta mañana",
      "SNOOZED_UNTIL_NEXT_WEEK": "Pospuesto hasta la próxima semana",
      "SNOOZED_UNTIL_NEXT_REPLY": "Posponer hasta la siguiente respuesta",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "perdido",
        "DUE": "vencido"
      },
      "MORE": "Más acciones"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marcar como pendiente",
      "SNOOZE_UNTIL": "Posponer",
      "SNOOZE": {
        "TITLE": "Posponer hasta",
        "NEXT_REPLY": "Siguiente respuesta",
        "TOMORROW": "Mañana",
        "NEXT_WEEK": "Próxima semana"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolver sin CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Posponer hasta",
      "APPLY": "Posponer",
      "CANCEL": "Cancelar"
    },
    "PRIORITY": {
      "TITLE": "Prioridad",
      "OPTIONS": {
        "NONE": "Ninguna",
        "URGENT": "Urgente",
        "HIGH": "Alta",
        "MEDIUM": "Media",
        "LOW": "Baja"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ninguna",
        "INPUT_PLACEHOLDER": "Seleccionar prioridad",
        "NO_RESULTS": "No se encontraron resultados",
        "SUCCESSFUL": "Se ha cambiado la prioridad del id de conversación {conversationId} a {priority}",
        "FAILED": "No se pudo cambiar la prioridad. Por favor, inténtelo de nuevo."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Abrir en una pestaña nueva",
      "COPY_LINK": "Copiar enlace de la conversación",
      "COPY_LINK_SUCCESS": "Enlace de la conversación copiado al portapapeles",
      "PENDING": "Marcar como pendiente",
      "RESOLVED": "Marcar como resuelto",
      "MARK_AS_UNREAD": "Marcar como no leído",
      "MARK_AS_READ": "Marcar como leído",
      "REOPEN": "Resolver conversación",
      "SNOOZE": {
        "TITLE": "Posponer",
        "NEXT_REPLY": "Hasta la siguiente respuesta",
        "TOMORROW": "Hasta mañana",
        "NEXT_WEEK": "Hasta la próxima semana"
      },
      "ASSIGN_AGENT": "Asignar un agente",
      "ASSIGN_LABEL": "Asignar etiqueta",
      "AGENTS_LOADING": "Cargando agentes...",
      "ASSIGN_TEAM": "Asignar equipo",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "ID de conversación {conversationId} asignado a \"{agentName}\"",
          "FAILED": "No se pudo asignar el agente. Por favor, inténtelo de nuevo."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Etiqueta #{labelName} asignada a la conversación con id {conversationId}",
          "FAILED": "No se pudo asignar el agente. Por favor, inténtelo de nuevo."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Equipo asignado \"{team}\" al ID de conversación {conversationId}",
          "FAILED": "No se pudo asignar el equipo. Por favor, inténtelo de nuevo."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Firma del mensaje",
      "ENABLE_SIGN_TOOLTIP": "Activar firma",
      "DISABLE_SIGN_TOOLTIP": "Desactivar firma",
      "MSG_INPUT": "Shift + enter for new line. Comience con '/' para seleccionar una respuesta predefinida.",
      "PRIVATE_MSG_INPUT": "Mayús + entrar para una nueva línea. Esto será visible sólo para los agentes",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "La firma del mensaje no está configurada, por favor configúrela en la configuración del perfil.",
      "CLICK_HERE": "Haga clic aquí para actualizar",
      "WHATSAPP_TEMPLATES": "Plantillas de Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "La ventana de 24 horas de WhatsApp ha expirado. Responde con una plantilla.",
      "INSERT_SIGNATURE": "Insertar firma en el editor",
      "SIGNATURE_PREVIEW_IMAGE": "(firma de imagen)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Tu respuesta parece estar en {draftLanguage}, pero esta conversación está en {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Traducir",
      "REPLY": "Responder",
      "PRIVATE_NOTE": "Nota privada",
      "SEND": "Enviar",
      "CREATE": "Añadir nota",
      "INSERT_READ_MORE": "Leer más",
      "DISMISS_REPLY": "Descartar respuesta",
      "REPLYING_TO": "Respondiendo a:",
      "TIP_FORMAT_ICON": "Mostrar editor de textos",
      "HEADING_LEVEL": {
        "LABEL": "Estilo de texto",
        "NORMAL": "Texto normal",
        "H1": "Encabezado 1",
        "H2": "Encabezado 2",
        "H3": "Encabezado 3"
      },
      "EDITOR": {
        "BOLD": "Negrita",
        "ITALIC": "Cursiva",
        "UNDERLINE": "Subrayado",
        "TEXT_COLOR": "Color de texto",
        "BG_COLOR_LABEL": "Color de fondo",
        "FONT_SIZE_LABEL": "Tamaño de fuente",
        "FONT_SIZE": {
          "XS": "Pequeño",
          "SM": "Mediano pequeño",
          "MD": "Predeterminado",
          "LG": "Grande",
          "XL": "Muy grande",
          "XXL": "Enorme"
        },
        "CODE": "Código",
        "LINK": "Añadir o quitar enlace",
        "CREATE_LINK": "Crear enlace",
        "SAVE_LINK": "Guardar",
        "CANCEL": "Cancelar",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Deshacer",
        "REDO": "Rehacer",
        "BULLET_LIST": "Lista con viñetas",
        "ORDERED_LIST": "Lista numerada",
        "BLOCKQUOTE": "Cita",
        "H1": "Encabezado 1",
        "H2": "Encabezado 2",
        "H3": "Encabezado 3",
        "IMAGE_UPLOAD": "Subir imagen",
        "CLEAR_FORMATTING": "Borrar formato",
        "COLOR": {
          "RED": "Rojo",
          "YELLOW": "Amarillo",
          "BLUE": "Azul",
          "ROSE_RED": "Rojo rosado",
          "DEEP_CYAN": "Cian oscuro",
          "ORANGE": "Naranja",
          "PISTACHIO": "Pistacho",
          "PURPLE": "Morado",
          "FUCHSIA": "Fucsia",
          "SILVER": "Plata",
          "NAVY": "Azul marino",
          "OLD_PINK": "Rosa viejo",
          "AQUA": "Aguamarina",
          "BROWN": "Marrón",
          "OLIVE": "Oliva",
          "GOLD": "Dorado",
          "BEIGE": "Beis",
          "WINE": "Vino",
          "FOREST": "Verde bosque",
          "GREEN": "Verde",
          "BLUE_GREY": "Gris azulado",
          "RUBY_RED": "Rojo rubí",
          "CHESTNUT_BROWN": "Marrón castaño",
          "ASH_GREY": "Gris ceniza"
        },
        "BG_COLOR": {
          "RED": "Rojo",
          "YELLOW": "Amarillo",
          "BLUE": "Azul",
          "ROSE_RED": "Rojo rosado",
          "DEEP_CYAN": "Cian oscuro",
          "ORANGE": "Naranja",
          "PISTACHIO": "Pistacho",
          "PURPLE": "Morado",
          "FUCHSIA": "Fucsia",
          "SILVER": "Plata",
          "NAVY": "Azul marino",
          "OLD_PINK": "Rosa viejo",
          "AQUA": "Aguamarina",
          "BROWN": "Marrón",
          "OLIVE": "Oliva",
          "GOLD": "Dorado",
          "BEIGE": "Beis",
          "WINE": "Vino",
          "FOREST": "Verde bosque",
          "GREEN": "Verde",
          "BLUE_GREY": "Gris azulado",
          "RUBY_RED": "Rojo rubí",
          "CHESTNUT_BROWN": "Marrón castaño",
          "ASH_GREY": "Gris ceniza"
        }
      },
      "TIP_EMOJI_ICON": "Mostrar selector de emoji",
      "TIP_ATTACH_ICON": "Adjuntar archivos",
      "TIP_AUDIORECORDER_ICON": "Grabar audio",
      "TIP_AUDIORECORDER_PERMISSION": "Permitir el acceso a audio",
      "TIP_AUDIORECORDER_ERROR": "No se pudo abrir el audio",
      "DRAG_DROP": "Arrastra y suelta aquí para adjuntar",
      "START_AUDIO_RECORDING": "Iniciar grabación de audio",
      "STOP_AUDIO_RECORDING": "Detener grabación de audio",
      "": "",
      "EMAIL_HEAD": {
        "TO": "A",
        "ADD_BCC": "Añadir bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Correos separados por comas",
          "ERROR": "Por favor, introduzca correo válido"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Correos separados por comas",
          "ERROR": "Por favor, introduzca correo válido"
        },
        "EDIT": "Editar",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Ocultar",
        "INCLUDE_ORIGINAL_MESSAGE": "Incluir mensaje original",
        "EDIT_HEADERS": "Editar",
        "HIDE_HEADER_EDITS": "Ocultar ediciones",
        "SUBJECT": {
          "LABEL": "ASUNTO",
          "PLACEHOLDER": "Asunto del correo",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variables indefinidas",
        "MESSAGE": "Tienes {undefinedVariablesCount} variables no definidas en tu mensaje: {undefinedVariables}. ¿Quieres enviar el mensaje de todos modos?",
        "CONFIRM": {
          "YES": "Enviar",
          "CANCEL": "Cancelar"
        }
      },
      "SEND_EMAIL": "Enviar correo",
      "SEND_SMS": "Enviar SMS",
      "NO_SMS_INBOX": "Agregue una bandeja de entrada de SMS para enviar respuestas por SMS.",
      "SEND_CHAT": "Enviar chat",
      "REPLY_TO_THIS": "Responder a esto",
      "TIP_EXPAND_ICON": "Ampliar editor",
      "TIP_COLLAPSE_ICON": "Reducir editor",
      "COPILOT": {
        "Q": "Pedir ayuda al robot"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota privada: solo visible para ti y tu equipo",
    "CHANGE_STATUS": "Estado de la conversación cambiado",
    "CHANGE_STATUS_FAILED": "Error al cambiar el estado de la conversación",
    "CHANGE_AGENT": "Conversación cambiada de asignatario",
    "CHANGE_AGENT_FAILED": "Error al cambiar el asignatario",
    "ASSIGN_LABEL_SUCCESFUL": "Etiqueta asignada correctamente",
    "ASSIGN_LABEL_FAILED": "No se ha podido asignar la etiqueta",
    "CHANGE_TEAM": "Equipo de conversación cambiado",
    "FILE_SIZE_LIMIT": "El archivo supera el límite de archivos adjuntos de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "MESSAGE_ERROR": "No se puede enviar este mensaje, por favor inténtalo de nuevo más tarde",
    "SENT_BY": "Enviado por:",
    "BOT": "Bot",
    "SEND_FAILED": "¡No se pudo enviar el mensaje! Inténtalo de nuevo",
    "TRY_AGAIN": "reintentar",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Seleccionar agente",
      "REMOVE": "Eliminar",
      "ASSIGN": "Asignar"
    },
    "CONTEXT_MENU": {
      "COPY": "Copiar",
      "REPLY_TO": "Responder a este mensaje",
      "DELETE": "Eliminar",
      "CREATE_A_CANNED_RESPONSE": "Añadir a respuestas predefinidas",
      "TRANSLATE": "Traducir",
      "COPY_PERMALINK": "Copiar el enlace al mensaje",
      "LINK_COPIED": "URL del mensaje copiado al portapapeles",
      "DELETE_CONFIRMATION": {
        "TITLE": "¿Está seguro que desea eliminar este mensaje?",
        "MESSAGE": "No puede deshacer esta acción",
        "DELETE": "Eliminar",
        "CANCEL": "Cancelar"
      },
      "FORWARD": "Reenviar",
      "FORWARD_ERROR": "Error al preparar el mensaje reenviado"
    },
    "SIDEBAR": {
      "CONTACT": "Contacto",
      "COPILOT": "Copilot"
    },
    "IMAGE_RESIZE": {
      "SMALL": "Pequeño",
      "MEDIUM": "Mediano",
      "LARGE": "Grande",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Mostrar mensajes ocultos",
    "TRANSCRIPT": {
      "SHOW": "Mostrar transcripción completa",
      "HIDE": "Ocultar transcripción completa",
      "DOWNLOAD": "Descargar transcripción",
      "COPY": "Copiar transcripción"
    },
    "INVISIBLE_TO_CUSTOMER": "Invisible para el cliente",
    "SENT_VIA_EMAIL": "También enviado al contacto por correo electrónico ({time})",
    "API_HOURS_WINDOW": "Solo puedes responder a esta conversación dentro de {hours} horas",
    "FACEBOOK_CANNOT_REPLY": "Si necesitas continuar esta conversación, ",
    "PENDING_WITH_BOT_BANNER": "Esta conversación está siendo gestionada por un bot de IA. Si quieres responder, abre la conversación primero.",
    "INBOX_DELETE_REQUESTED_BANNER": "Esta bandeja de entrada está marcada para eliminación, por lo que la respuesta del cliente nunca llegaría. Mueve la conversación a otra bandeja de entrada para responder.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Este contacto tiene otra conversación abierta #{id}",
      "MULTIPLE": "Este contacto tiene otras conversaciones abiertas ({count})",
      "OPEN": "Abrir",
      "SHOW": "Mostrar"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Esta cuenta de Instagram fue migrada a la nueva bandeja de entrada del canal de Instagram. Todos los nuevos mensajes aparecerán allí. Ya no podrás enviar mensajes desde esta conversación.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "No se puede enviar el mensaje porque el cliente no está en línea y la continuidad por correo no está disponible.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "El cliente no está en línea. Es posible que no reciba los mensajes ya que la continuidad por correo no está disponible.",
    "OPEN_FILE": "Abrir",
    "DOWNLOAD_ATTACHMENTS": "Descargar todo",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Descargar todos los adjuntos uno por uno",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Descargar todo como ZIP",
    "ERROR_DOWNLOADING_FILE": "Error al descargar el archivo",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Pedir al cliente que comparta su número de teléfono de WhatsApp",
      "PENDING_ACTION": "Solicitud de información de contacto pendiente",
      "STATES": {
        "PENDING": "Esperando información de contacto",
        "SHARED": "Número de teléfono compartido",
        "IDENTITY_CONFLICT": "Número de teléfono por revisar"
      }
    },
    "SLA": {
      "BREACHED": "incumplido"
    },
    "IMAGE_UPLOAD_ERROR": "No se puede subir la imagen, por favor inténtalo de nuevo",
    "DRAFT": {
      "FILE_TOO_LARGE": "El archivo \"{fileName}\" ({fileSize}) es demasiado grande para almacenar en el borrador y será omitido",
      "ATTACHMENT_SERIALIZATION_FAILED": "Error al serializar el adjunto para el almacenamiento del borrador",
      "STORAGE_QUOTA_EXCEEDED": "Cuota de almacenamiento excedida. Borrador guardado sin adjuntos",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Error al guardar el borrador incluso sin adjuntos",
      "SAVE_FAILED": "Error al guardar el borrador de la conversación"
    },
    "COMMENT_TREE": {
      "TITLE": "Hilo de comentarios",
      "EMPTY": "No hay comentarios para mostrar",
      "VIEW_TREE": "Ver hilo de comentarios"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "La conversación fue marcada por {userName}",
          "CONTACT_RESOLVED": "Conversación fue resuelta por {contactName}",
          "OPEN": "La conversación fue reabierta por {userName}",
          "PENDING": "La conversación fue marcada como pendiente por {userName}",
          "SNOOZED": "La conversación fue pospuesta por {userName}",
          "AUTO_RESOLVED": "La conversación fue marcada por el sistema debido a {duration} días de inactividad",
          "SYSTEM_AUTO_OPEN": "El sistema reabrió la conversación debido a un nuevo mensaje entrante.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "La conversación fue marcada como resuelta por {userName} (sin CSAT)",
          "AUTO_RESOLVED_INACTIVE": "La conversación fue marcada como resuelta por el sistema debido a {duration} horas de inactividad",
          "AUTO_RESOLVED_EMPTY": "La conversación fue marcada como resuelta por el sistema por estar vacía.",
          "BLOCKED_CONTACT_RESOLVED": "El sistema resolvió la conversación porque el contacto está bloqueado.",
          "KAUFLAND_TICKET_CLOSED": "El sistema resolvió la conversación porque el ticket se cerró en Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} estableció la prioridad a {newPriority}",
          "UPDATED": "{userName} cambió la prioridad de {oldPriority} a {newPriority}",
          "REMOVED": "{userName} eliminó la prioridad"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} auto-asignado a esta conversación",
          "ASSIGNED": "Asignado a {assigneeName} por {userName}",
          "REMOVED": "Conversación no asignada por {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Asignado a {teamName} por {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Asignado a {assigneeName} via {teamName} por {userName}",
          "REMOVED": "Desasignado de {teamName} por {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} agregó {labels}",
          "REMOVED": "{userName} eliminó a {labels}"
        },
        "SLA": {
          "ADDED": "{userName} agregó la política de SLA {slaName}",
          "REMOVED": "{userName} eliminó la política de SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} ha silenciado la conversación",
        "UNMUTED": "{userName} ha anulado el silenciado de la conversación",
        "CONTACT_BLOCKED": "{userName} bloqueó el contacto",
        "CONTACT_UNBLOCKED": "{userName} desbloqueó el contacto",
        "AUTO_RESOLUTION_MESSAGE": "Resolviendo la conversación, ya que ha estado inactiva durante un tiempo. Por favor, inicia una nueva conversación si necesitas más ayuda.",
        "DOMAIN_BLOCKED": "{userName} bloqueó todos los contactos para un dominio determinado",
        "DOMAIN_UNBLOCKED": "{userName} desbloqueó todos los contactos para un dominio determinado",
        "MERGED": "{userName} fusionó la conversación #{sourceId} con esta conversación",
        "MOVED": "{userName} movió esta conversación de la bandeja {sourceInboxName} a la bandeja {targetInboxName}",
        "MOVED_BY_ORDER": "Movida porque los pedidos del contacto provienen solo de la tienda {storeName} (último pedido {orderId}), cuyo robot responde en esta bandeja.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Se omitió la acción de envío de mensaje para este mensaje de respuesta automática",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "La automatización se omitió porque el contacto está bloqueado",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "La automatización \"{ruleName}\" no pudo mover esta conversación de la bandeja de entrada {sourceInboxName} a la bandeja de entrada {targetInboxName} porque las bandejas no son compatibles.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "La automatización \"{ruleName}\" no pudo mover esta conversación de la bandeja de entrada {sourceInboxName} a la bandeja de entrada {targetInboxName} porque el contacto no tiene dirección de correo electrónico.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "La automatización \"{ruleName}\" no pudo enviar un mensaje: esta bandeja de entrada telefónica no puede enviar SMS porque la cuenta no tiene ninguna bandeja de entrada SMS. La regla se desactivó y los administradores recibieron un correo electrónico.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "La automatización \"{ruleName}\" no pudo enviar un mensaje: los adjuntos no se pueden enviar por SMS desde esta bandeja de entrada. La regla se desactivó y los administradores recibieron un correo electrónico.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "La macro \"{macroName}\" no envió su mensaje: esta bandeja de entrada telefónica no puede enviar SMS porque la cuenta no tiene ninguna bandeja de entrada SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "La macro \"{macroName}\" no envió su mensaje: los adjuntos no se pueden enviar por SMS desde esta bandeja de entrada.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "La macro \"{macroName}\" no envió su mensaje: el bot está gestionando esta conversación. Abra primero la conversación.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "La macro \"{macroName}\" no envió su mensaje: esta bandeja de entrada está marcada para eliminación. Mueva primero la conversación a otra bandeja de entrada.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "La automatización \"{ruleName}\" envió un correo electrónico a {contactEmail} en una nueva conversación [#{conversationId}]({conversationPath}) en la bandeja de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "La automatización \"{ruleName}\" inició esta conversación a raíz de la conversación [#{conversationId}]({conversationPath}) en la bandeja de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "La automatización \"{ruleName}\" no pudo enviar el mensaje en una nueva conversación en la bandeja de entrada {inboxName} porque el contacto no tiene dirección de correo electrónico.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "La automatización \"{ruleName}\" envió un SMS a {contactPhone} en una nueva conversación [#{conversationId}]({conversationPath}) en la bandeja de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "La automatización \"{ruleName}\" no pudo enviar el SMS en una nueva conversación en la bandeja de entrada {inboxName} porque el contacto no tiene número de teléfono.",
        "AUTOMATION_RULE_TRIGGERED": "Regla de automatización \"{ruleName}\" activada",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "La regla de automatización \"{ruleName}\" deshabilitó la prioridad automática",
        "AUTOMATION_SKIP_AUTO_LABELING": "La regla de automatización \"{ruleName}\" deshabilitó el etiquetado automático",
        "AUTOMATION_STOP_PROCESSING_RULES": "La regla de automatización \"{ruleName}\" detuvo el procesamiento posterior de reglas",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agente",
            "CUSTOMER": "Cliente"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "contestada en otro lugar, sonó {duration}",
            "NO_ANSWER": "sin contestar, sonó {duration}",
            "REJECTED": "rechazada, sonó {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Resuelta automáticamente tras devoluciones de llamada sin éxito: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Grabación de la llamada eliminada por {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Enviar transcripción de la conversación",
    "DESC": "Enviar un copia de la transcripción a un dirección de correo especificada",
    "SUBMIT": "Enviar",
    "CANCEL": "Cancelar",
    "SEND_EMAIL_SUCCESS": "La transcripción ha sido enviada",
    "SEND_EMAIL_ERROR": "Hubo un error, por favor inténtelo de nuevo",
    "FORM": {
      "SEND_TO_CONTACT": "Enviar la transcripción al cliente",
      "SEND_TO_AGENT": "Enviar la transcripción al agente asignado",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Enviar la transcripción a otra dirección de correo",
      "EMAIL": {
        "PLACEHOLDER": "Escriba la dirección de correo",
        "ERROR": "Por favor, introduzca una dirección de correo válida"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hola 👋, ¡Bienvenido a {installationName}!",
    "DESCRIPTION": "Gracias por registrarse. Queremos que saque el máximo provecho de {installationName}. Aquí hay algunas cosas que puede hacer en {installationName} para hacer que la experiencia sea agradable.",
    "GREETING_MORNING": "👋 Buenos días, {name}. Bienvenido a  {installationName}.",
    "GREETING_AFTERNOON": "👋 Buenas tardes, {name}. Bienvenido a  {installationName}.",
    "GREETING_EVENING": "👋 Buenas noches, {name}. Bienvenido a  {installationName}.",
    "READ_LATEST_UPDATES": "Leer nuestras últimas actualizaciones",
    "ALL_CONVERSATION": {
      "TITLE": "Todas sus conversaciones en un solo lugar",
      "DESCRIPTION": "Ver todas las conversaciones de sus clientes en un solo panel de control. Puede filtrar las conversaciones por el canal entrante, etiqueta y estado.",
      "NEW_LINK": "Haga clic aquí para crear una bandeja de entrada"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite a los miembros de su equipo",
      "DESCRIPTION": "Ya que usted se está preparando para hablar con su cliente, traiga a sus compañeros para asistirle. Puedes invitar a sus compañeros de equipo añadiendo su dirección de correo electrónico a la lista de agentes.",
      "NEW_LINK": "Haga clic aquí para invitar a un miembro del equipo"
    },
    "LABELS": {
      "TITLE": "Organice las conversaciones con etiquetas",
      "DESCRIPTION": "Las etiquetas proporcionan una forma fácil de clasificar su conversación. Cree algunas etiquetas como #pregunta-soporte, #pregunta-dacturación etc., para que pueda usarlas en una conversación más tarde.",
      "NEW_LINK": "Haga clic aquí para crear etiquetas"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Crea respuestas predefinidas",
      "DESCRIPTION": "Las respuestas predefinidas son plantillas preconfiguradas que le ayudan a responder rápidamente a una conversación. Los agentes pueden escribir el carácter '/' seguido por el código corto para insertar una respuesta predefinida durante una conversación.",
      "NEW_LINK": "Haga clic aquí para crear una respuesta predefinida"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agente asignado",
    "SELF_ASSIGN": "Asignar a mi",
    "TEAM_LABEL": "Equipo asignado",
    "SELECT": {
      "PLACEHOLDER": "Ninguna"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Datos personalizados",
      "CONTACT_DETAILS": "Detalles de contacto",
      "CONVERSATION_ACTIONS": "Acciones de conversación",
      "CONVERSATION_LABELS": "Etiquetas de conversación",
      "CONVERSATION_INFO": "Información de la conversación",
      "CONTACT_ATTRIBUTES": "Atributos de contacto",
      "PREVIOUS_CONVERSATION": "Conversaciones anteriores",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Historial de pedidos",
      "RETINO_TICKETS": "Tickets de Retino"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pendientes",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Crear atributo",
    "NO_RECORDS_FOUND": "No se encontraron atributos",
    "UPDATE": {
      "SUCCESS": "Atributo actualizado correctamente",
      "ERROR": "No se puede actualizar el atributo. Por favor, inténtalo de nuevo más tarde"
    },
    "ADD": {
      "TITLE": "Añadir",
      "SUCCESS": "Atributo añadido correctamente",
      "ERROR": "No se puede agregar atributo. Por favor, inténtalo de nuevo más tarde"
    },
    "DELETE": {
      "SUCCESS": "Atributo eliminado correctamente",
      "ERROR": "No se puede eliminar el atributo. Por favor, inténtalo de nuevo más tarde"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Añadir atributos",
      "PLACEHOLDER": "Buscar atributos",
      "NO_RESULT": "No se encontraron atributos"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Desde",
    "TO": "Para",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Asunto"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participar",
    "SIDEBAR_TITLE": "Participantes de la conversación",
    "NO_RECORDS_FOUND": "No se encontraron resultados",
    "ADD_PARTICIPANTS": "Seleccionar participantes",
    "REMANING_PARTICIPANTS_TEXT": "+{count} más",
    "REMANING_PARTICIPANT_TEXT": "+{count} más",
    "TOTAL_PARTICIPANTS_TEXT": "{count} personas están participando.",
    "TOTAL_PARTICIPANT_TEXT": "{count} personas están participando.",
    "NO_PARTICIPANTS_TEXT": "Nadie está participando!.",
    "WATCH_CONVERSATION": "Abrir conversación",
    "YOU_ARE_WATCHING": "Estás participando",
    "API": {
      "ERROR_MESSAGE": "No se pudo actualizar, ¡inténtelo de nuevo!",
      "SUCCESS_MESSAGE": "¡Participantes actualizados!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Ver contenido traducido",
    "DESC": "Puedes ver el contenido traducido en cada lenguaje.",
    "ORIGINAL_CONTENT": "Contenido original",
    "TRANSLATED_CONTENT": "Contenido traducido",
    "NO_TRANSLATIONS_AVAILABLE": "No hay traducciones disponibles para este contenido"
  },
  "TYPING": {
    "ONE": "{user} está escribiendo",
    "TWO": "{user} y {secondUser}  están escribiendo",
    "MULTIPLE": "{user} y {count}  otros están escribiendo",
    "IMAGE_ALT": "Alguien está escribiendo"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Prueba estas sugerencias"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "No se pudo descargar el archivo adjunto. Por favor, inténtelo de nuevo"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No se encontraron datos",
    "LOAD_ERROR": "No se pudieron cargar los datos. Inténtalo de nuevo más tarde."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Cargar más",
    "NO_RECORDS_FOUND": "No se encontraron tickets",
    "LOAD_ERROR": "No se pueden cargar los tickets de {hookName}. Por favor, inténtalo más tarde.",
    "NOT_SEARCHABLE": "El correo electrónico del contacto no está configurado.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Cargando...",
    "NO_ORDERS": "No se encontraron pedidos",
    "NOT_AVAILABLE": "Datos del cliente no disponibles",
    "EXPAND": "Abrir perfil del cliente",
    "MORE_ITEMS": "+ {count} artículos",
    "EXPEDITION_STATUS": "Estado del envío",
    "OPEN_DETAIL": "abrir detalle",
    "COPY_ORDER_ID": "Número de pedido",
    "EXTERNAL_ID": "ID externo",
    "PAYMENT_TYPE": "Método de pago",
    "PAYMENT_DATE": "Fecha de pago",
    "DELIVERY_PROVIDER": "Transportista",
    "EXPECTED_DATE_OF_DELIVERY": "Entrega prevista",
    "DATE_OF_DELIVERY": "Entregado el",
    "EXPEDITION_DATE": "Fecha de expedición",
    "INTERNAL_NOTE": "Nota de la tienda",
    "PACKAGE_NUMBER": "Paquete"
  },
  "READING": {
    "ONE": "{user} está leyendo este ticket",
    "TWO": "{user} y {secondUser} están leyendo este ticket",
    "MULTIPLE": "{user} y {count} otros están leyendo este ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Mover conversación",
    "DESCRIPTION": "Mueve esta conversación a otra bandeja de entrada de correo.",
    "SOURCE": {
      "TITLE": "Conversación",
      "ID_LABEL": "ID de la conversación"
    },
    "TARGET": {
      "TITLE": "Bandeja de entrada de destino",
      "PLACEHOLDER": "Selecciona una bandeja de entrada de correo",
      "NO_RESULTS": "No hay otras bandejas de entrada de correo disponibles",
      "ERROR": "Por favor, selecciona una bandeja de entrada de destino"
    },
    "SUBMIT": "Mover conversación",
    "CANCEL": "Cancelar",
    "SUCCESS_MESSAGE": "Conversación movida correctamente",
    "ERROR_MESSAGE": "No se pudo mover la conversación. Por favor, inténtalo de nuevo."
  },
  "MERGE": {
    "TITLE": "Fusionar conversaciones",
    "DESCRIPTION": "Fusiona esta conversación con otra. Todos los mensajes de esta conversación se moverán a la conversación de destino, y esta conversación se eliminará.",
    "SOURCE": {
      "TITLE": "Conversación de origen (se eliminará)",
      "ID_LABEL": "ID de la conversación"
    },
    "TARGET": {
      "TITLE": "Conversación de destino",
      "PLACEHOLDER": "Escribe el ID de la conversación para buscar (por ejemplo, 123)",
      "HELP": "Introduce el ID de la conversación a la que fusionar todos los mensajes.",
      "ERROR": "Por favor, selecciona una conversación de destino"
    },
    "WARNING": "Advertencia: Esta acción no se puede deshacer. Todos los mensajes se moverán a la conversación de destino y esta conversación se eliminará permanentemente.",
    "SUBMIT": "Fusionar conversaciones",
    "CANCEL": "Cancelar",
    "SUCCESS_MESSAGE": "Conversación fusionada correctamente",
    "ERROR_MESSAGE": "No se pudieron fusionar las conversaciones. Por favor, comprueba la conversación de destino e inténtalo de nuevo.",
    "SEARCH": {
      "NO_RESULTS": "No se encontró ninguna conversación con este ID",
      "ERROR_MESSAGE": "No se pudieron buscar conversaciones. Por favor, inténtalo de nuevo."
    },
    "CONFIRM": {
      "TITLE": "Confirmar fusión",
      "DESCRIPTION": "¿Estás seguro de que deseas fusionar esta conversación? Esta acción no se puede deshacer.",
      "YES": "Sí, fusionar",
      "CANCEL": "Cancelar"
    }
  }
}
